import React from 'react';
import styled from 'styled-components';

const Box = styled.div`
  position: absolute;
  border: 2px solid red;
  background-color: rgba(255, 0, 0, 0.1);
  pointer-events: none;
`;

const Label = styled.div`
  position: absolute;
  top: -24px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1001;
`;

const BoundingBoxOverlay = ({ bbox, containerWidth, pdfDimensions, label }) => {
  if (!bbox || bbox.length !== 4) {
    console.warn('Invalid bbox:', bbox);
    return null;
  }

  // Correct bbox destructuring [x1, y1, x2, y2]
  const [x1, y1, x2, y2] = bbox;
  
  // Calculate actual dimensions from normalized coordinates
  const NORMALIZATION_BASE = 1000;
  const scaleX = containerWidth / NORMALIZATION_BASE;
  const scaleY = (containerWidth * (pdfDimensions.height / pdfDimensions.width)) / NORMALIZATION_BASE;
  
  // Calculate position and dimensions
  const scaledX = Math.round(x1 * scaleX);
  const scaledY = Math.round(y1 * scaleY);
  const scaledWidth = Math.round((x2 - x1) * scaleX);
  const scaledHeight = Math.round((y2 - y1) * scaleY);

  console.log('Bounding Box Debug:', {
    original: { x1, y1, x2, y2 },
    pdfDimensions,
    containerWidth,
    scaleX,
    scaleY,
    scaled: { 
      x: scaledX, 
      y: scaledY, 
      width: scaledWidth, 
      height: scaledHeight 
    }
  });

  const style = {
    position: 'absolute',
    left: `${scaledX}px`,
    top: `${scaledY - 5}px`,
    width: `${scaledWidth}px`,
    height: `${scaledHeight + 6}px`,
    zIndex: 900,
    transform: 'translate(0, 0)', // Reset any transforms
  };

  return (
    <Box style={style}>
      <Label>
        {label || 'Unknown'}
      </Label>
    </Box>
  );
};

export default BoundingBoxOverlay; 